// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__3UDA9","copy":"footer_copy__IKq7f"};